import { Flex, Text, Tooltip } from '@radix-ui/themes'
import cn from 'clsx'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FaInstagram, FaFacebook } from 'react-icons/fa'

import { ROOT_I18NEXT } from '#app/routes/_layout/route-config.ts'
import { testId } from '#app/utils/client/test-id.ts'

/* -------------------------------------------------------------------------------------------------
 * SocialMedia
 * -----------------------------------------------------------------------------------------------*/

enum TEST_ID {
	'social-media' = 'social-media',
}

type SocialMediaProps = {
	isColor?: boolean
}

const SocialMedia: React.FC<SocialMediaProps> = () => {
	const { t } = useTranslation(ROOT_I18NEXT.routeRoot)
	const list = [
		{
			color: 'text-[#8DA4EF]',
			Icon: FaFacebook,
			label: t('label.facebook'),
			link: 'https://www.facebook.com/profile.php?id=100088719575512',
		},
		{
			color: 'text-[#FA934E]',
			Icon: FaInstagram,
			label: t('label.instagram'),
			link: 'https://instagram.com/suwe_kosmetik',
		},
	]

	return (
		<Flex
			asChild
			align="center"
			justify="center"
			gapX="4"
			{...testId(TEST_ID['social-media'])}
		>
			<ul>
				{list.map(({ color, Icon, label, link }) => (
					<li key={link}>
						<Tooltip content={label}>
							<a href={link} target="_blank" rel="noreferrer">
								<Text aria-label={label}>
									<Icon
										className={cn(
											color,
											'transition duration-200 ease-in-out',
											'hover:scale-110',
											{
												'h-6 w-6': color,
												'h-10 w-10': !color,
											},
										)}
									/>
								</Text>
							</a>
						</Tooltip>
					</li>
				))}
			</ul>
		</Flex>
	)
}
SocialMedia.displayName = 'SocialMedia'

/* -----------------------------------------------------------------------------------------------*/

export { SocialMedia, TEST_ID as SOCIAL_MEDIA_TEST_ID }
